import React, { PropsWithChildren } from "react";

import { clsx } from "clsx";

type Props = {
  label?: string;
  centered?: boolean;
  uppercase?: boolean;
  className?: string;
  headingLevel: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
};

const Heading = ({
  label,
  children,
  headingLevel,
  centered,
  uppercase,
  className,
}: PropsWithChildren<Props>) => {
  const Title = headingLevel;

  return (
    <Title
      className={clsx({
        [`${className ? className : ""}`]: className,
        ta_center: centered,
        uppercase,
      })}
    >
      {label && label}
      {children && children}
    </Title>
  );
};

export default Heading;
